import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/Badge";
import { buttonStyles } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { PageHeader } from "@/components/ui/PageHeader";

const pillars = [
  {
    title: "Client-side por completo",
    text: "Toda a experiência roda no navegador, sem backend, sem autenticação tradicional e sem dependências de runtime fora do cliente."
  },
  {
    title: "Persistência resiliente",
    text: "Os dados são gravados com prioridade em IndexedDB e podem cair para localStorage quando necessário."
  },
  {
    title: "Preparado para offline",
    text: "A arquitetura e a saída estática já deixam o terreno pronto para service worker e cache local na próxima etapa."
  }
];

export function HomePage() {
  return (
    <div className="grid gap-8">
      <PageHeader
        eyebrow="Base estática"
        title="Um grimório digital para heróis, lendas e campanhas"
        description="Crie, organize e mantenha fichas de personagens diretamente no navegador com um visual de fantasia medieval elegante, arquitetura modular e publicação simples como arquivos estáticos."
        actions={
          <div className="flex flex-wrap gap-3">
            <Link to="/characters/new" className={buttonStyles()}>
              Começar uma ficha
            </Link>
            <Link to="/dashboard" className={buttonStyles("secondary")}>
              Abrir dashboard
            </Link>
          </div>
        }
      />

      <section className="panel-surface grid gap-8 overflow-hidden p-8 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="space-y-6">
          <Badge tone="gold">Inspirado em fantasia medieval heroica</Badge>
          <div className="space-y-4">
            <h2 className="text-4xl leading-tight sm:text-5xl">
              Forje personagens com presença, memória local e estrutura escalável.
            </h2>
            <p className="max-w-2xl text-base leading-8 text-mist">
              Esta base foi pensada para crescer em cima de componentes reutilizáveis,
              rotas client-side e um domínio de dados separado da interface. Ela já
              suporta criação, edição, exclusão e gerenciamento local de fichas.
            </p>
          </div>
          <div className="grid gap-4 sm:grid-cols-3">
            <div className="rounded-3xl border border-gold/15 bg-black/15 p-5">
              <p className="text-xs uppercase tracking-[0.22em] text-mist">Runtime</p>
              <p className="mt-3 text-2xl text-parchment">100% navegador</p>
            </div>
            <div className="rounded-3xl border border-gold/15 bg-black/15 p-5">
              <p className="text-xs uppercase tracking-[0.22em] text-mist">Saída</p>
              <p className="mt-3 text-2xl text-parchment">dist/ estático</p>
            </div>
            <div className="rounded-3xl border border-gold/15 bg-black/15 p-5">
              <p className="text-xs uppercase tracking-[0.22em] text-mist">Dados</p>
              <p className="mt-3 text-2xl text-parchment">Local-first</p>
            </div>
          </div>
        </div>

        <div className="rounded-[2rem] border border-gold/20 bg-black/20 p-6">
          <div className="space-y-5">
            <div>
              <p className="text-xs uppercase tracking-[0.24em] text-gold">Visão da etapa</p>
              <h3 className="mt-3 text-2xl">Escopo inicial entregue</h3>
            </div>
            <ul className="space-y-3 text-sm leading-7 text-mist">
              <li>Estrutura modular por domínio e camada.</li>
              <li>Roteamento pronto para publicação estática via hash.</li>
              <li>Tema visual com atmosfera de grimório nobre e responsivo.</li>
              <li>Páginas iniciais para home, dashboard, criação, ficha e configurações.</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="grid gap-6 lg:grid-cols-3">
        {pillars.map((pillar) => (
          <Card key={pillar.title} title={pillar.title}>
            <p className="text-sm leading-7 text-mist">{pillar.text}</p>
          </Card>
        ))}
      </section>
    </div>
  );
}
